export default "__VITE_ASSET__DrzuD4DL__"